import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KindService } from 'app/services/models/kind.service';
import { PersonLeaveService } from 'app/services/models/person-leave.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import moment from 'moment';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-person-leave',
  templateUrl: './person-leave.component.html',
  styleUrls: ['./person-leave.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PersonLeaveComponent implements OnInit {
  @Input() data: { personId: number; row: any };
  personLeaveForm: FormGroup;

  kinds: any[] = [];

  date = new Date();
  date2 = moment().add(10, 'days').toDate();

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date
  };

  public dateTimeEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date2
  };

  statusList: any[] = [
    { id: 1, name: "Onay bekleniyor." },
    { id: 2, name: "Onaylandı" },
    { id: 3, name: "Reddet" }
  ]

  constructor(
    public activeModal: NgbActiveModal,
    private personLeaveService: PersonLeaveService,
    private kindService: KindService,
    private fb: FormBuilder,
    private toastrService: ToastrService) { }

  async ngOnInit() {
    this.personLeaveForm = this.fb.group({
      status: [1],
      leaveDay: [1],
      startDate: [null],
      endDate: [null],
      kindId: [null, [Validators.required]],
      personId: this.data.personId
    });
    await this.getAllKinds();
    console.log(this.data);
    if (this.data.row) {
      this.date = new Date(this.data.row.startDate);
      this.date2 = new Date(this.data.row.endDate);
      this.personLeaveForm.patchValue({
        endDate: this.data.row.endDate,
        startDate: this.data.row.startDate,
        kindId: this.data.row.kindId,
        status: this.data.row.status,
        leaveDay: this.data.row.leaveDay
      })
    }
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 100, 12);
    console.log(data);
    this.kinds = data.types;
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSumbit() {
    if (this.personLeaveForm.valid) {
      console.log(this.personLeaveForm.value);
      const startDate = new Date(this.personLeaveForm.value.startDate);
      const endDate = new Date(this.personLeaveForm.value.endDate);
      if (this.data.row) {
        const response = await this.personLeaveService.updatePersonLeave(
          this.data.row.id,
          this.personLeaveForm.value.status,
          this.personLeaveForm.value.leaveDay,
          startDate,
          endDate,
          this.personLeaveForm.value.kindId,
          this.personLeaveForm.value.personId
        );
        if (response.status == true) {
          this.toastrService.success(response.message);
          this.closeModal();
          this.personLeaveService.sendEvent(true);
        } else {
          this.toastrService.error(response.message);
        }
      } else {
        const response = await this.personLeaveService.createPersonLeave(
          1,
          this.personLeaveForm.value.leaveDay,
          startDate,
          endDate,
          this.personLeaveForm.value.kindId,
          this.personLeaveForm.value.personId
        );
        if (response.status == true) {
          this.toastrService.success(response.message);
          this.closeModal();
          this.personLeaveService.sendEvent(true);
        } else {
          this.toastrService.error(response.message);
        }
      }

    }
  }
}